<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition :title="$t('Global.Main.callDetailManagement')"
      icon="mdi mdi-card-account-phone-outline" />

    <v-container fluid class="fill-width mb-5">
      <v-sheet color="background" class="px-2 mb-5 neu-glow">
        <dashboard-call-filters @apply-filters="applyFilters" :phoneNumber="phoneNumber" :fromDate="dateRange[0]"
          :toDate="dateRange[1]" />
      </v-sheet>

      <v-sheet color="background" class="px-2 mb-5 neu-glow">
        <v-list color="background">
          <v-list-item v-if="selectedPhoneNumber">
            <span class="text-subtitle-2 mr-2">Teléfono seleccionado:</span> {{ selectedPhoneNumber }}
          </v-list-item>
          <v-list-item v-if="dateRangeText">
            <span class="text-subtitle-2 mr-2">Rango de fechas:</span> {{ dateRangeText }}
          </v-list-item>
        </v-list>
      </v-sheet>

      <!-- Mostrar tabla solo cuando hay datos y no está en estado de carga -->
      <v-data-table v-if="!loading && data.length" :headers="dynamicHeaders" :items="filteredData" class="elevation-1" dense header-class="custom-header">
        <template v-slot:[`item.extTrackingId`]="{ item }">
          <td>{{ item.extTrackingId }}
            <v-btn icon @click="openModal(item.extTrackingId)">
            <v-icon>mdi-eye</v-icon>
      </v-btn>
          </td>
        </template>
        <template v-slot:[`item.origin`]="{ item }">
        <td>{{ item.origin }}</td>
        </template>
        <template v-slot:[`item.destination`]="{ item }">
          <td>{{ item.destination }}</td>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <td>{{ item.type }}</td>
        </template>
        <template v-slot:[`item.extensionNumber`]="{ item }">
          <td>{{ item.extensionNumber }}</td>
        </template>
        <template v-slot:[`item.statusType`]="{ item }">
          <td>{{ item.statusType }}</td>
        </template>
        <template v-slot:[`item.arrivedDate`]="{ item }">
          <td>{{ formatDate(item.arrivedDate) }}</td>
        </template>
        <template v-slot:[`item.answerDate`]="{ item }">
          <td>{{ formatDate(item.answerDate) }}</td>
        </template>
        <template v-slot:[`item.releaseDate`]="{ item }">
          <td>{{ formatDate(item.releaseDate) }}</td>
        </template>
        <template v-slot:[`item.holdTime`]="{ item }">
          <td>{{ formatDuration(item.holdTime) }}</td>
        </template>
        <template v-slot:[`item.callTime`]="{ item }">
          <td>{{ formatDuration(item.callTime) }}</td>
        </template>
        <template v-slot:[`item.totalHeldTime`]="{ item }">
          <td>{{ formatDuration(item.totalHeldTime) }}</td>
        </template>
      </v-data-table>

      <!-- Modal para mostrar todos los datos -->
      <v-dialog v-model="showModal" max-width="1800px">
        <v-card>
          <v-card-title class="text-h5">
      Detalle de Llamadas - ID: {{ selectedCallId }}
    </v-card-title>

    <v-card-text>
      <!-- Contenido del modal: Mostrar datos relacionados con el ID de llamada seleccionado -->
      <v-data-table :headers="dynamicHeaders" :items="selectedCallData" class="elevation-1">
        <template v-slot:[`item.extTrackingId`]="{ item }">
          <td>{{ item.extTrackingId }}</td>
        </template>
        <template v-slot:[`item.origin`]="{ item }">
          <td>{{ item.origin }}</td>
        </template>
        <template v-slot:[`item.destination`]="{ item }">
          <td>{{ item.destination }}</td>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <td>{{ item.type }}</td>
        </template>
        <template v-slot:[`item.extensionNumber`]="{ item }">
          <td>{{ item.extensionNumber }}</td>
        </template>
        <template v-slot:[`item.statusType`]="{ item }">
          <td>{{ item.statusType }}</td>
        </template>
        <template v-slot:[`item.arrivedDate`]="{ item }">
          <td>{{ formatDate(item.arrivedDate) }}</td>
        </template>
        <template v-slot:[`item.answerDate`]="{ item }">
          <td>{{ formatDate(item.answerDate) }}</td>
        </template>
        <template v-slot:[`item.releaseDate`]="{ item }">
          <td>{{ formatDate(item.releaseDate) }}</td>
        </template>
        <template v-slot:[`item.holdTime`]="{ item }">
          <td>{{ formatDuration(item.holdTime) }}</td>
        </template>
        <template v-slot:[`item.callTime`]="{ item }">
          <td>{{ formatDuration(item.callTime) }}</td>
        </template>
        <template v-slot:[`item.totalHeldTime`]="{ item }">
          <td>{{ formatDuration(item.totalHeldTime) }}</td>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="showModal = false">Cerrar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

      
      <!-- Mostrar mensaje solo si no hay datos disponibles después de la búsqueda -->
  <v-alert v-if="noDataMessage" :value="true" color="warning" icon="mdi-alert">
  No hay datos disponibles para el número y las fechas seleccionadas.
  </v-alert>

    </v-container>
  </div>
</template>

<script>
import DashboardCallFilters from './DashBoardCallFilters.vue';
import ReportsApi from "@/mixins/Services/ReportsApi";
import Utils from "@/mixins/Utils";

export default {
  name: 'DashBoardCall',
  components: {
    DashboardCallFilters,
  },
  mixins: [ReportsApi, Utils],
  data() {
    return {
      phoneNumber: '',
      selectedPhoneNumber: '',
      dateRange: [],
      data: [],
      dataToSend: {},
      dynamicHeaders: [],
      loading: false,
      noDataMessage: false,
      showModal: false, // Control para el modal
      selectedCallId: null,
      selectedCallData: [], // Datos filtrados por ID de llamada para el modal
      headerMapping: {
        extTrackingId: 'Id Llamada',
        origin: 'Origen',
        destination: 'Destino',
        type: 'Tipo',
        extensionNumber: 'Extensión',
        statusType: 'Estado',
        arrivedDate: 'Fecha Entrada',
        answerDate: 'Fecha Contestación',
        releaseDate: 'Fecha Cuelgue',
        natureRelease: 'Naturaleza Cuelgue',
        holdTime: 'Tiempo Sonando',
        callTime: 'Duración Llamada',
        totalHeldTime: 'Tiempo Espera',
      },
    };
  },
  computed: {
    dateRangeText() {
      if (this.dateRange.length === 2) {
        return `${this.dateRange[0]} a ${this.dateRange[1]}`;
      }
      return '';
    },
  },
  methods: {
    populateFilteredData() {
      const uniqueIds = new Set();
      this.filteredData = this.data.filter(item => {
        if (!uniqueIds.has(item.extTrackingId)) {
          uniqueIds.add(item.extTrackingId);
          return true;
        }
        return false;
      });
    },
    recoverRequestData(filters) {
      // Asegurarse de que las fechas estén en formato correcto
      const fromDateMillis = new Date(filters.fromDate).getTime();
      const toDateMillis = new Date(filters.toDate).getTime();

      this.dataToSend = {
        type: 'CALL_DETAIL_RECORD',
        from: fromDateMillis,
        to: toDateMillis,
        granularity: filters.granularity?.granularityTypeName || null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
        agentId: filters.agent?.agentId || null,
        remoteParty: filters.phoneNumber || null,
        queueId: filters.queue?.nodeId || null,
        groupId: filters.group?.groupId || null,
        companyId: this.loadCompanyId()
      };
    },

    // Formatear las fechas a 'YYYY-MM-DD' o 'YYYY-MM-DD HH:mm:ss'
    formatDate(timestamp) {
      if (timestamp === null || timestamp === undefined || timestamp === 0) {
        return '';
      }
      if (typeof timestamp === 'number') {
      const date = new Date(timestamp);
      return date.toLocaleString('es-ES', { 
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        hour12: false, // Formato 24 horas
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
    return timestamp;
  },

    async applyFilters(filters) {
      this.selectedPhoneNumber = filters.phoneNumber;
      this.phoneNumber = filters.phoneNumber;

      const fromDateFormatted = this.formatDate(filters.fromDate);
      const toDateFormatted = this.formatDate(filters.toDate);

      this.dateRange = [fromDateFormatted, toDateFormatted];
      this.recoverRequestData(filters);
      await this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      this.noDataMessage = false;
      this.data = [];
      this.filteredData = []; // Limpiamos el filteredData antes de llenarlo
      this.dynamicHeaders = [];

      console.debug('[REPORTS][viewReport] Sending data:', this.dataToSend);

      try {
        const reportData = await this.visualizeCDRReport(this.dataToSend);
        if (Array.isArray(reportData) && reportData.length) {
          this.data = reportData;
          this.populateFilteredData();

          this.dynamicHeaders = Object.keys(reportData[0]).map(key => ({
            text: this.headerMapping[key] || key,
            value: key,
          }));
        } else {
          console.warn('[REPORTS][viewReport] No valid data returned');
          this.noDataMessage = true;
        }
      } catch (error) {
        console.error('[REPORTS][viewReport] ERROR:', error);
        this.$emit('launch-snackbar', this.$t('Global.Error.generalError'), 'error', "4000", 'mdi-alert-octagon');
        this.noDataMessage = true;
      } finally {
        this.loading = false;
      }
    },

    openModal(callId) {
      this.selectedCallId = callId;
      this.selectedCallData = this.data.filter(item => item.extTrackingId === callId);
      this.showModal = true;
    },

    // Función para formatear las duraciones (milisegundos a HH:mm:ss)
    formatDuration(milliseconds) {
    if (typeof milliseconds === 'number') {
      const seconds = Math.floor(milliseconds / 1000);
      const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      const remainingSeconds = String(seconds % 60).padStart(2, '0');
      return `${hours}:${minutes}:${remainingSeconds}`;
    }
    return ''; // Valor por defecto si no hay datos
  },
  },
};
</script>

<style>

td {
  width: 100px; /* Customize as per requirement */
}

</style>

